<template>
    <div class="chart-container">
      <b-card class="sales-chart">
        <b-card-header>
          <b-card-title>Quantity of Sales Over Time</b-card-title>
        </b-card-header>

  
        <!-- Line Chart -->
        <apexcharts
          ref="chart"
          height="350"
          type="line"
          :options="chartOptions"
          :series="filteredChartData"
        ></apexcharts>
      </b-card>
    </div>
  </template>
  
  <script>
  import VueApexCharts from "vue-apexcharts";
  import { BCard, BCardTitle, BCardHeader, BRow, BCol, BFormInput } from "bootstrap-vue";
  
  export default {
    name: "SalesOverTimeChart",
    components: {
      apexcharts: VueApexCharts,
      BCard,
      BCardTitle,
      BCardHeader,
      BRow,
      BCol,
      BFormInput,
    },
    props: {
      data: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    data() {
      return {
       
        salesData: [
          { date: "2024-01-01", quantity: 120 },
          { date: "2024-01-02", quantity: 150 },
          { date: "2024-01-03", quantity: 180 },
          { date: "2024-01-04", quantity: 90 },
          { date: "2024-01-05", quantity: 130 },
          { date: "2024-01-06", quantity: 170 },
          { date: "2024-01-07", quantity: 140 },
          { date: "2024-01-08", quantity: 200 },
          { date: "2024-01-09", quantity: 80 },
          { date: "2024-01-10", quantity: 160 }
        ],
     
        startDate: "2024-01-01",
        endDate: "2024-01-10",
        chartOptions: {
          chart: {
            type: "line",
            height: 350,
          },
          xaxis: {
            categories: [], 
            title: { text: "Date" },
          },
          yaxis: {
            title: { text: "Quantity of Sales" },
          },
          stroke: {
            curve: "smooth",
          },
        },
      };
    },
    computed: {
      filteredChartData() {
    
        // const filtered = this.salesData.filter((item) => {
        //   return item.date >= this.startDate && item.date <= this.endDate;
        // });
        return [
          {
            name: "Sales",
            data: this.data.map((item) => item.salesCount),
          },
        ];
      },
    },
    methods: {
      updateChart() {
       
        // const filtered = this.salesData.filter((item) => {
        //   return item.date >= this.startDate && item.date <= this.endDate;
        // });
        this.chartOptions.xaxis.categories = this.data.map((item) => item.period);
      },
    },
    mounted() {
      
      this.updateChart();
    },
  };
  </script>
  

  